export const GA_MEASUREMENT_ID = 'G-WY6LT6K4B3';

// Initialize Google Analytics
export const initGA = () => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('config', GA_MEASUREMENT_ID, {
            page_location: window.location.href,
            page_title: document.title,
        });
    }
};

// Track page views
export const trackPageView = (path, title) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('config', GA_MEASUREMENT_ID, {
            page_location: `${window.location.origin}${path}`,
            page_title: title,
        });
    }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value,
        });
    }
};

// Track scroll depth
export const trackScrollDepth = (percentage) => {
    trackEvent('scroll', 'engagement', 'scroll_depth', percentage);
};

// Track time on section
export const trackTimeOnSection = (section, timeSpent) => {
    trackEvent('timing_complete', 'engagement', section, Math.round(timeSpent / 1000));
};

// Track contact form interactions
export const trackContactForm = (action, method) => {
    trackEvent(action, 'contact', method);
};

// Track portfolio project views
export const trackProjectView = (projectName) => {
    trackEvent('view_project', 'portfolio', projectName);
};

// Track social media clicks
export const trackSocialClick = (platform) => {
    trackEvent('click', 'social_media', platform);
};

// Track resume/CV downloads
export const trackResumeDownload = () => {
    trackEvent('download', 'resume', 'cv_pdf');
};

// Track external link clicks
export const trackExternalLink = (url, linkText) => {
    trackEvent('click', 'external_link', `${linkText} - ${url}`);
};